<template>
  <VeeForm
    v-slot="{
      handleSubmit,
      isSubmitting,
      isValidating,
      meta,
      resetForm,
      values,
    }"
    as="div"
    :validation-schema="schema"
    :initial-values="initialValues"
    @invalid-submit="$emit('invalid-submit')"
  >
    <form
      @submit="
        handleSubmit($event, (submitValues: any) =>
          handleSubmitCallBack(submitValues, resetForm),
        )
      "
    >
      <slot :values="values" />

      <div class="mt-8 flex justify-end">
        <slot name="footer" />
        <Button
          type="submit"
          :label="submitLabel ?? $t('common.cta.submit')"
          :loading="isSubmitting || isValidating || isProcessingSubmission"
          :disabled="!meta.valid || !meta.dirty"
          :class="{
            'w-full': submitFullWidth,
            'ml-2': $slots.footer,
          }"
        />
      </div>
    </form>
  </VeeForm>
</template>

<script setup lang="ts">
import { Form as VeeForm } from 'vee-validate'

const props = defineProps<{
  schema: Record<string, any>
  initialValues?: Record<string, any> // TODO: Type depending schema
  onSubmit: (values: any) => Promise<void>
  submitLabel?: string
  submitFullWidth?: boolean
  resetOnSubmit?: boolean
}>()
defineEmits<{
  'invalid-submit': () => void
}>()

const { t } = useI18n()
const toast = usePrimevueToast()

// TODO: Remove
const isProcessingSubmission = ref(false)
// TODO: Type values with schema
const handleSubmitCallBack = async (values: any, resetForm: any) => {
  try {
    isProcessingSubmission.value = true
    await props.onSubmit(values)
    resetForm(props.resetOnSubmit ? undefined : { values })
  }
  catch (error) {
    toast.add({
      severity: 'error',
      summary: t('common.label.error'),
      detail: error.message,
      life: 5000,
    })
    const { $sentryCaptureException } = useNuxtApp()
    $sentryCaptureException(error)
  }
  finally {
    isProcessingSubmission.value = false
  }
}
</script>
